import { useState, useEffect } from 'react'
import { PackageService } from '../services/packageService'
import { Package } from '../config/api'

export const usePackage = (slug: string) => {
  const [packageData, setPackageData] = useState<Package | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const packageService = PackageService.getInstance()

  useEffect(() => {
    const fetchPackage = async () => {
      if (!slug) return

      try {
        setLoading(true)
        setError(null)
        
        const data = await packageService.getPackageBySlug(slug)
        setPackageData(data)
        
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch package')
      } finally {
        setLoading(false)
      }
    }

    fetchPackage()
  }, [slug, packageService])

  const refresh = async () => {
    if (!slug) return
    
    try {
      setLoading(true)
      setError(null)
      const data = await packageService.getPackageBySlug(slug)
      setPackageData(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch package')
    } finally {
      setLoading(false)
    }
  }

  return {
    packageData,
    loading,
    error,
    refresh,
  }
} 